export default __webpack_public_path__ + "assets/images/pin.c4b413c1.svg";